import { render, staticRenderFns } from "./DogRegistrationIndividualRequest.vue?vue&type=template&id=43719b9b"
import script from "./DogRegistrationIndividualRequest.vue?vue&type=script&lang=ts"
export * from "./DogRegistrationIndividualRequest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports